import Index from "./index";
import BMITracksDetail from "./BMITracksDetail";

export const BMITracksRoutes = [
  {
    name: "BMI Tracks",
    path: "/admin/BMITracks",
    element: <Index />,
  },
  {
    name: "BMI Tracks Detail",
    path: "/admin/BMITracks/:id",
    element: <BMITracksDetail />,
  },
];
